/**
 * @file 文档页页面路由
 * @author wanzhongyun
 */
import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Document from './Document';

const DocRoute = () => {
    return (
        <BrowserRouter>
            <Switch>
                <Route path="/documentation" component={Document} />
            </Switch>
        </BrowserRouter>
    );
};

export default DocRoute;
